import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle,
} from 'components/common/Dialog';

import { submit } from 'redux-form';

import Button from 'components/common/Button';
import DeliveryDialogForm from './DeliveryDialogForm';

const styles = theme => ({
  form: {
    padding: '40px 60px 40px',
    [theme.breakpoints.down('sm')]: {
      padding: '16px 8px 16px',
    },
  },
});

const CMNSelectionDialog = ({
  form,
  open,
  onClose,
  onSubmitSuccess,
  initialValues,
  formValues,
  actions,
  onPrintEditPreviewButtonClick,
  variant,
  classes,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
  >
    <DialogTitle>
      <Typography
        variant="title"
        color="secondary"
        align="center"
      >
        Delivery Information
      </Typography>
    </DialogTitle>
    <DialogContent>
      <DeliveryDialogForm
        className={classes.form}
        form={form}
        initialValues={initialValues}
        formValues={formValues}
        variant={variant}
        onSubmitSuccess={(values) => {
          onSubmitSuccess(values);
        }}
      />
    </DialogContent>
    <DialogActions>
      <Button
        onClick={onClose}
        variant="raised"
      >
        Cancel
      </Button>
      <Button
        onClick={() => {
          actions.submit(form);
        }}
        variant="raised"
        color="primary"
      >
        OK
      </Button>
    </DialogActions>
  </Dialog>
);

CMNSelectionDialog.propTypes = {
  open: PropTypes.bool,
  form: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  onSubmitSuccess: PropTypes.func,
  initialValues: PropTypes.shape({
    'CMN/AMB': PropTypes.string,
  }),
  formValues: PropTypes.shape({
    'Primary Insurance ID': PropTypes.number,
  }),
  onPrintEditPreviewButtonClick: PropTypes.func,
  variant: PropTypes.oneOf(['default', 'no-driver']),
  classes: PropTypes.shape({
    form: PropTypes.string.isRequired,
  }).isRequired,
};

CMNSelectionDialog.defaultProps = {
  open: false,
  initialValues: {},
  onClose: () => {},
  onSubmitSuccess: () => {},
  formValues: {},
  onPrintEditPreviewButtonClick: () => {},
  variant: 'default',
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ submit }, dispatch),
});

export default connect(null, mapDispatchToProps)(
  withStyles(styles)(CMNSelectionDialog),
);



// WEBPACK FOOTER //
// ./src/components/workflow/DeliveryDialog/DeliveryDialog.js